module.exports = __webpack_public_path__ + "static/WindingWorlds3-d3a11a43b46da69b9934074bc8854460.png";